module.exports = __webpack_public_path__ + "static/media/wave-grc-5.0d0d2c2b.svg";